import React from "react";

const HeroSection = ({ title, description, image, link, reverse }) => (
  <section style={{
    display: "flex",
    flexDirection: reverse ? "row-reverse" : "row",
    alignItems: "center",
    justifyContent: "center",
    padding: "4rem 2rem",
    gap: "0.5rem",
    flexWrap: "wrap",
    background: "rgba(255,255,255,0.03)"
  }}>
    <img src={image} alt={title} style={{
      width: "100%",
      maxWidth: "500px",
      borderRadius: "12px",
      boxShadow: "0 0 20px rgba(0,0,0,0.4)"
    }} />
    <div style={{ maxWidth: "500px", color: "white", textAlign: "left" }}>
      <h2 style={{ fontSize: "2rem", marginBottom: "1rem" }}>{title}</h2>
      <p style={{ fontSize: "1.1rem", marginBottom: "1.5rem" }}>{description}</p>
      <a href={link} style={{
        background: "white",
        color: "black",
        padding: "0.6rem 1.2rem",
        borderRadius: "6px",
        textDecoration: "none",
        fontWeight: "bold"
      }}>Explore</a>
    </div>
  </section>
);

export default HeroSection;
